import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import { auth } from "@/lib/firebase";
import { signOut } from "firebase/auth";
import { Button, buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
// import { useTheme } from "next-themes";
import { 
  Moon, 
  Sun, 
  Laptop, 
  BookOpen, 
  Store, 
  User as UserIcon, 
  LogOut, 
  BarChart3
} from "lucide-react";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { useEffect, useState } from "react";

export default function Navbar() {
  const { user } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="sticky top-0 z-50 w-full border-b bg-background/80 backdrop-blur-xl supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-20 items-center justify-between px-4 sm:px-6">
        <div className="flex items-center gap-6 md:gap-10">
          <Link to={user ? "/dashboard" : "/"} className="flex items-center space-x-2">
            <BookOpen className="h-6 w-6 text-primary" />
            <span className="hidden font-bold sm:inline-block text-xl tracking-tight">
              FLASH<span className="text-primary">CARD</span>
            </span>
          </Link>
          <div className="hidden md:flex gap-8">
            {user && (
              <Link to="/dashboard" className={cn("text-sm font-semibold transition-all hover:scale-105", isActive("/dashboard") ? "text-primary border-b-2 border-primary pb-0.5" : "hover:text-primary")}>
                Dashboard
              </Link>
            )}
            <Link to="/decks" className={cn("text-sm font-semibold transition-all hover:scale-105", isActive("/decks") ? "text-primary border-b-2 border-primary pb-0.5" : "hover:text-primary")}>
              Bộ thẻ của tôi
            </Link>
            <Link to="/marketplace" className={cn("text-sm font-semibold transition-all hover:scale-105 flex items-center gap-1.5", isActive("/marketplace") ? "text-primary border-b-2 border-primary pb-0.5" : "hover:text-primary")}>
              <Store className="h-4 w-4" /> Chợ cộng đồng
            </Link>
            <Link to="/analytics" className={cn("text-sm font-semibold transition-all hover:scale-105 flex items-center gap-1.5", isActive("/analytics") ? "text-primary border-b-2 border-primary pb-0.5" : "hover:text-primary")}>
              <BarChart3 className="h-4 w-4" /> Thống kê
            </Link>
          </div>
        </div>

        <div className="flex items-center gap-4">
          {/* Theme toggler simplified or removed temporarily */}
          
          {user ? (
            <>
              <DropdownMenu>
                <DropdownMenuTrigger render={<Button variant="outline" size="sm" className="gap-2" />}>
                  <UserIcon className="h-4 w-4" />
                  <span className="hidden sm:inline">{user.displayName || user.email}</span>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-56">
                  <DropdownMenuItem onClick={() => navigate("/profile")} className="cursor-pointer">
                    Profile
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => navigate("/settings")} className="cursor-pointer">
                    Settings
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={handleLogout} className="text-destructive cursor-pointer">
                    <LogOut className="mr-2 h-4 w-4" /> Sign Out
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </>
          ) : (
            <div className="flex items-center gap-2">
              <Link 
                to="/login" 
                className={cn(buttonVariants({ variant: "ghost", size: "sm" }))}
              >
                Login
              </Link>
              <Link 
                to="/register" 
                className={cn(buttonVariants({ size: "sm" }))}
              >
                Get Started
              </Link>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}


